var map = {
	"./asset-hyperlink.json": 6917,
	"./blockquote.json": 7983,
	"./document.json": 8370,
	"./embedded-asset-block.json": 2430,
	"./embedded-entry-block.json": 9968,
	"./embedded-entry-inline.json": 9724,
	"./embedded-resource-block.json": 3242,
	"./embedded-resource-inline.json": 4120,
	"./entry-hyperlink.json": 4042,
	"./heading-1.json": 2407,
	"./heading-2.json": 524,
	"./heading-3.json": 791,
	"./heading-4.json": 6056,
	"./heading-5.json": 4605,
	"./heading-6.json": 5598,
	"./hr.json": 530,
	"./hyperlink.json": 6189,
	"./list-item.json": 9040,
	"./ordered-list.json": 799,
	"./paragraph.json": 4435,
	"./resource-hyperlink.json": 7124,
	"./table-cell.json": 4910,
	"./table-header-cell.json": 2794,
	"./table-row.json": 1598,
	"./table.json": 673,
	"./text.json": 7474,
	"./unordered-list.json": 5206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6889;